import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Skeleton } from 'antd'
import Routes from './routes'
import client from './utils/client'
import { AuthProvider } from './contexts/AuthContext'
import { LocalizationProvider } from './contexts/LocalizationContext'
import './App.less'
import { ThemeProvider } from '@contexts/ThemeContext'
import BuddhaEra from 'dayjs/plugin/buddhistEra'
import 'dayjs/locale/th'
import dayjs from 'dayjs'
dayjs.extend(BuddhaEra)

const App = () => (
  <LocalizationProvider>
    <ThemeProvider>
      <Router>
        <AuthProvider
          forbiddenPath="/forbidden"
          client={client}
          loadingComponent={() => <Skeleton />}
        >
          <Routes />
        </AuthProvider>
      </Router>
    </ThemeProvider>
  </LocalizationProvider>
)

export default App
